module.exports = {
    version: '811fe89'
}


//////////////////
// WEBPACK FOOTER
// ./server/version.js
// module id = 3244
// module chunks = 0